import React from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@material-ui/core";
import RTL from "../../../../components/RTL";
import mockData from "./data";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Pagination from '@material-ui/lab/Pagination';


const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  imageInput: {
    display: "none",
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));

const TrucksList = (props) => {
  const classes = useStyles();
  const { onDelete ,ChangeId,onEdit} = props;
  return (
    <RTL>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">نوع ماشین</TableCell>

              <TableCell align="center" sortDirection="desc">
                عملیات
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {mockData.map((typeContract) => (
              <TableRow hover key={typeContract.id}>
                <TableCell align="center">{typeContract.typeContract}</TableCell>

                <TableCell align="center">
                  <IconButton
                    style={{ color: "#2196f3" }}
                    onClick={()=>{
                      onEdit();
                      ChangeId(typeContract.id)
                    }}
                    color="error"
                    aria-label="upload picture"
                    component="span"
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    style={{ color: "#E65D62" }}
                    onClick={()=>{
                      onDelete();
                      ChangeId(typeContract.id)
                    }}
                    color="error"
                    aria-label="upload picture"
                    component="span"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </TableContainer>

      <Pagination style={{margin:10}} variant="outlined" count={5} color="primary" />

    </RTL>
    
  );
};

export default TrucksList;
